import Const from '@/helpers/const'
import { custAxios } from './genericApi'

export default {
  sendSuggestion (params) {
    return custAxios().post(`${Const.API_SUGGEST}`, params)
  }
}
